<template>
    <div>
        <transition name="fade">
            <div class="loader" v-show="show">
                <svg id="coin" data-name="preloader" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="85" height="75" viewBox="0 0 170 150">

                    <circle id="spincoin" r="70" cx="90" cy="50"/><circle id="spincoin2" r="80" cx="85" cy="40"/>
                    <circle id="shadowcoin" r="80" cx="85" cy="40"/>

                </svg>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
  name: "Loader",
  data() {
    return {};
  },
  computed: {
    show() {
      return this.$store.state.system.loading;
    }
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.loader {
  background: #ffffff;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 1000000;
}
#coin {
  display: block;
  margin: 0 auto;
  top: 50%;
  position: relative;
  transform: scale(2) translateY(-50%);
}
#spincoin {
  fill: #f0b700;
  transform-origin: 80px 30px;
  opacity: 1;
  animation: spin 1.1s linear infinite;
  mix-blend-mode: normal;
}
#small {
  /*   transform: translateX(-12px); */
  animation: roll 1.1s linear infinite;
}
#spincoin2 {
  fill: #70117e;
  transform-origin: 80px 30px;
  animation: rev-spin 1.5s linear infinite;
  mix-blend-mode: overlay;
}
#shadowcoin {
  fill: #f1daff;
  transform-origin: 80px 80px;
  animation: shadow 0.7s linear infinite;
  mix-blend-mode: multiply;
}
@keyframes spin {
  0% {
    transform: translateY(4px) rotateX(60deg) rotateY(0deg);
  }
  13% {
    transform: translateY(18px) rotateX(75deg) rotateY(13deg);
  }
  25% {
    transform: translateY(11px) rotateX(90deg) rotateY(27deg);
  }
  38% {
    transform: translateY(22px) rotateX(75deg) rotateY(13deg);
  }
  50% {
    transform: translateY(11px) rotateX(60deg) rotateY(0deg);
  }
  63% {
    transform: translateY(22px) rotateX(75deg) rotateY(-13deg);
  }
  75% {
    transform: translateY(18px) rotateX(90deg) rotateY(-27deg);
  }
  89% {
    transform: translateY(18px) rotateX(75deg) rotateY(-13deg);
  }
  100% {
    transform: translateY(4px) rotateX(60deg) rotateY(0deg);
  }
}
@keyframes roll {
  0% {
    transform: translateY(1px) translateX(-20px);
  }
  50% {
    transform: translateY(0px) translateX(-5px);
  }
  100% {
    transform: translateY(1px) translateX(-20px);
  }
}
@keyframes rev-spin {
  100% {
    transform: translateY(4px) rotateX(60deg) rotateY(0deg);
  }
  89% {
    transform: translateY(18px) rotateX(75deg) rotateY(13deg);
  }
  75% {
    transform: translateY(11px) rotateX(90deg) rotateY(27deg);
  }
  63% {
    transform: translateY(22px) rotateX(75deg) rotateY(13deg);
  }
  50% {
    transform: translateY(11px) rotateX(60deg) rotateY(0deg);
  }
  38% {
    transform: translateY(22px) rotateX(75deg) rotateY(-13deg);
  }
  25% {
    transform: translateY(18px) rotateX(90deg) rotateY(-27deg);
  }
  13% {
    transform: translateY(18px) rotateX(75deg) rotateY(-13deg);
  }
  0% {
    transform: translateY(4px) rotateX(60deg) rotateY(0deg);
  }
}
@keyframes shadow {
  0% {
    transform: translateY(3px) scaleY(0.05) scaleX(1);
    fill: #f1daff;
  }
  25% {
    transform: translateY(3px) scaleY(0.05) scaleX(0.91);
    fill: #f1daa9;
  }
  50% {
    transform: translateY(3px) scaleY(0.05) scaleX(1);
    fill: #f1daff;
  }
  75% {
    transform: translateY(3px) scaleY(0.05) scaleX(0.91);
    fill: #f1daa9;
  }
  100% {
    transform: translateY(3px) scaleY(0.05) scaleX(1);
    fill: #f1daff;
  }
}
</style>
